import api from './api';

class FuturesService {
  // Obtenir les paires futures
  async getFuturesPairs() {
    const response = await api.get('/futures/pairs');
    return response.data;
  }

  // Créer un ordre futures
  async createOrder(orderData) {
    const response = await api.post('/futures/orders', orderData);
    return response.data;
  }

  // Obtenir les ordres futures
  async getFuturesOrders(params = {}) {
    const response = await api.get('/futures/orders', params);
    return response.data;
  }

  // Obtenir les positions ouvertes
  async getOpenPositions() {
    const response = await api.get('/futures/positions');
    return response.data;
  }

  // Fermer une position
  async closePosition(positionId) {
    const response = await api.post(`/futures/positions/${positionId}/close`);
    return response.data;
  }

  // Annuler un ordre futures
  async cancelOrder(orderId) {
    const response = await api.delete(`/futures/orders/${orderId}`);
    return response.data;
  }

  // Mettre à jour TP/SL d'une position
  async updateTPSL(positionId, data) {
    const response = await api.put(`/futures/positions/${positionId}/tpsl`, data);
    return response.data;
  }
}

const futuresService = new FuturesService();
export default futuresService;